import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { Global, ThemeProvider } from '@emotion/react';

import App from './App';
import GlobalStyles, { theme } from './globalStyles';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        {/* Core SEO */}
        <title>
          Locumspace - Connect with Healthcare Professionals for Locum Jobs in
          Nigeria
        </title>
        <meta
          name='description'
          content='Join Locumspace to effortlessly connect with qualified healthcare professionals in Nigeria, for temporary, part-time & contract roles. Find locum doctor, nurse, and medical roles. Streamline your staffing needs today!'
        />
        <meta
          name='keywords'
          content='Locum Doctor, Locum Nurse, Locum Pharmacist, Temporary Medical Jobs Nigeria, Healthcare Recruitment Nigeria, Part-Time Medical Officer'
        />
        <meta name='robots' content='index, follow' />
        <link rel='canonical' href='https://locumspace.co/' />

        {/* Open Graph */}
        <meta property='og:site_name' content='Locumspace' />
        <meta
          property='og:title'
          content='Locumspace - Connect with Healthcare Professionals for Locum Jobs in Nigeria'
        />
        <meta
          property='og:description'
          content='Discover temporary, contract & part-time healthcare roles—locum doctors, nurses & more—across Lagos, Abuja & beyond.'
        />
        <meta property='og:type' content='website' />
        <meta property='og:image' content='https://locumspace.co/logo512.png' />
        <meta property='og:url' content='https://locumspace.co/' />

        {/* Twitter Card */}
        <meta name='twitter:site' content='@locumspace' />
        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='Locumspace - Connect with Healthcare Professionals Seamlessly'
        />
        <meta
          name='twitter:description'
          content='Join Locumspace to effortlessly connect with qualified healthcare professionals. Streamline your staffing needs today!'
        />
        <meta
          name='twitter:image'
          content='https://locumspace.co/logo512.png'
        />
      </Helmet>

      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <Global styles={GlobalStyles} />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
